/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {Image} from '@chakra-ui/react';
import {Heading, Box, Divider} from '@chakra-ui/react';
import HtmlElements from '../../components/HtmlElements';
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    pre: "pre",
    code: "code"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: "It’s always nice to have a website load quickly, especially on mobile devices. One way to help the load time is to decrease the number of bits that need to fly through the airwaves to make up the website."
    }), "\n", _jsx(_components.p, {
      children: "Here is a quick bit of PHP that can automagically minify the CSS before it is sent – just paste it at the top of the file and change the file extension to .php. Voila!"
    }), "\n", _jsx(_components.pre, {
      children: _jsx(_components.code, {
        className: "language-php",
        children: "<?php\nheader('Content-type: text/css');\nob_start(\"compress\");\nfunction compress($buffer) {\n\t/* remove comments */\n\t$buffer = preg_replace('!/\\*[^*]*\\*+([^/][^*]*\\*+)*/!', '', $buffer);\n\t/* remove tabs, spaces, newlines, etc. */\n\t$buffer = str_replace(array(\"\\r\\n\", \"\\r\", \"\\n\", \"\\t\", '  ', '    ', '    '), '', $buffer);\n\treturn $buffer;\n}\n?>\n"
      })
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
